import QuoteDetailHeader from '../QuoteDetailHeader/QuoteDetailHeader';
import QuoteDetailNotice from '../QuoteDetailNotice/QuoteDetailNotice';
import QuoteDetailCommercialUploadCard from '../QuoteDetailCommercialUploadCard/QuoteDetailCommercialUploadCard';
import QuoteDetailProcurementUploadCard from '../QuoteDetailProcurementUploadCard/QuoteDetailProcurementUploadCard';
import { EQuoteType, IQuoteApiResponse } from 'types/quote.types';
import { IQuoteHistory } from 'types/quoteDetails.types';
import './QuoteDetailExploratoryLayout.scss';

interface IQuoteDetailExploratoryLayout {
  quote: IQuoteApiResponse;
  isLoading: boolean;
  onRefresh: () => void;
  history?: IQuoteHistory;
  lastItemStatusChange?: string;
  onCancelSuccess?: () => Promise<void>;
}

/**
 * Layout del detalle de cotización exploratoria.
 * Reutiliza el header existente, muestra el banner SLA y organiza dos cards en columnas
 * para las planillas cargadas por comercial (izquierda) y por procurement (derecha).
 */
const QuoteDetailExploratoryLayout = ({
  quote,
  isLoading,
  onRefresh,
  history,
  lastItemStatusChange,
  onCancelSuccess
}: IQuoteDetailExploratoryLayout) => {
  return (
    <div className="quoteDetailExploratoryLayout">
      <QuoteDetailHeader
        isLoading={isLoading}
        id={quote.id}
        quoteType={EQuoteType.EXPLORATORY}
        quoteStatus={quote.quoteStatus}
        history={history}
        responsibles={quote.responsibles}
        onResponsiblesUpdate={onRefresh}
        requestedByUser={quote.requestedByUser}
        requestedCountry={quote.requestedCountry}
        createdAt={quote.createdAt}
        organizationName={quote.organizationName}
        organizationId={quote.organizationId}
        parentQuoteId={quote.parentQuoteId}
        lastItemStatusChange={lastItemStatusChange}
        onCancelSuccess={onCancelSuccess}
        referenceCode={quote.referenceCode}
      />

      <QuoteDetailNotice
        isLoading={isLoading}
        slas={quote.slas}
        slaElapsedHours={quote.slaElapsedHours}
        quoteStatusCode={quote.quoteStatus?.code}
        items={quote.items}
        isExploratory
      />

      <section className="exploratoryColumns">
        <QuoteDetailCommercialUploadCard bulkUpload={quote.commercialBulkUpload} />
        <QuoteDetailProcurementUploadCard
          quoteId={quote.id}
          bulkUpload={quote.procurementBulkUpload}
          neededToDate={quote.neededToDate}
          onUploadSuccess={onRefresh}
        />
      </section>
    </div>
  );
};

export default QuoteDetailExploratoryLayout;
